module.exports = __webpack_public_path__ + "img/mobile_activity_feed_preview.eff8335e.png";